import { render, staticRenderFns } from "./goggleForm.vue?vue&type=template&id=bf38ee02&scoped=true"
import script from "./goggleForm.vue?vue&type=script&lang=js"
export * from "./goggleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38ee02",
  null
  
)

export default component.exports